import React from 'react';
import { SDA_TABLE_CLASSES, SDA_TABLE_STYLE, SDA_HEADING_CELL_CLASSES, SdaColGroup } from './test-tile';
import { SDA_RESULTS_COLUMN_HEADINGS } from './sda-results-column-headings';

/**
 * SDA's Clause/Requirement/Result/Observations/Recommendations column-heading row for PRINT
 * output — rendered once per printed page via the CSS `display: table-header-group` repeating-
 * header mechanism (see PrintableReport.tsx's `.sda-print-table` wrapper and print.css), not
 * once per tile (raytd/web QA 108.02, item 2). The interactive view already hoists this same
 * label set once above the (non-paginated) results list via SdaResultsColumnHeadings — this is
 * that component's print counterpart, using the same SDA_TABLE_CLASSES/SdaColGroup widths so the
 * repeating header lines up with each tile's own columns, and the same label text (imported, not
 * re-typed) so the two can't drift apart. Table-family (raytd/web#153), like the interactive
 * heading and the tile's own content row it repeats above.
 */
const SdaPrintColumnHeadings: React.FC = () => (
    <table
        data-testid="sda-print-column-headings"
        className={`${SDA_TABLE_CLASSES} py-1 border-b border-zinc-200`}
        style={SDA_TABLE_STYLE}
    >
        <SdaColGroup />
        <thead>
            <tr>
                {SDA_RESULTS_COLUMN_HEADINGS.map((heading) => (
                    <th key={heading} className={SDA_HEADING_CELL_CLASSES}>
                        {heading}
                    </th>
                ))}
            </tr>
        </thead>
    </table>
);

export default SdaPrintColumnHeadings;
